import React, { memo } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './constants.tsx';
import { Nav4Recommendations as Nav4RecommendationsWithoutErrorBoundary } from './ui/Nav4Recommendations.tsx';

export const Nav4Recommendations = memo(RecommendationsQuery);

function RecommendationsQuery() {
	return (
		<JSErrorBoundary
			id="growth-recommendations"
			fallback="unmount"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<Placeholder name="recommendations">
				<Nav4RecommendationsWithoutErrorBoundary />
			</Placeholder>
		</JSErrorBoundary>
	);
}
